module.exports = __webpack_public_path__ + "static/media/enelLogo.08501762.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/enelLogo.png
// module id = 1754
// module chunks = 0